<template>
  <div>
    <div>
      <a @click="serGeet" class="code-num" :class="['', '', {disabled: isTimeout,'code-num-ltr':!isDirection,'code-num-rtl':isDirection}]">
        <span v-if="isTimeout">{{ $t('300062', {timeout: timeout}) }}</span>
        <span v-else>{{ $t('300061') }}</span>
      </a>
    </div>
    <Geet v-if="isGeet" :isGeet="isgt" @geetPath="GeetPath" @clickChange="GeetChange" product="bind"
          :userName="userName"></Geet>
    <!--    <div class="model" v-if="showImgCode" @click="showImgCode = false">-->
    <!--      <div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%">-->
    <!--        <VueHcaptcha sitekey="4f12a0ca-d812-40e1-a599-b642bf9e8988" @verify="onVerify"></VueHcaptcha>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
import Geet from "./Geet";
import {Popup, Icon, Toast} from 'vant'
import {sendCode, onlineSendCode, loginSendCode, bindSendCode} from "../api/user";
import {mapGetters} from 'vuex'

export default {
  name: "sendCode",
  components: {VueHcaptcha, vanPopup: Popup, vanIcon: Icon, Geet},
  props: {
    // 验证码类型
    codeType: {
      type: [Number, String],
      default: 1
    },
    flag: {
      type: [Number, String],
      default: ''
    },
    imgCode: {
      type: String,
      default: ''
    },

    userType: {
      type: [Number, String],
      default: 1
    },
    countryCode: {
      type: String,
      default: '',
    },
    safePwd: {
      type: String,
      default: '',
    },
    isElement: {
      type: Boolean,
      default: false
    },
    cardId: {
      type: String,
      default: '',
    },
    userName: {
      type: [String, Number],
      default: ''
    },
    //用于登录验证都key
    validationToken: {
      type: String,
      default: ''
    },
    successFun: {
      type: Function,
      default: function () {
      }
    },
    errorFun: {
      type: Function,
      default: function () {
      }
    },
    isGeet: {
      type: Boolean,
      default: false
    },
    formType: {
      type: String,
      default: '',
    },
    interfaceType: {  // 调用获取验证码的接口类型  online:在线,login:登录，bind:绑定，normal:注册，忘记密码
      type: String,
      default: ''
    },
    isCountDown: { // 是否直接启动倒计时
      type: Boolean,
      default: false
    },
    countDownFun: {
      type: Function,
      default: function () {
      }
    }
  },
  data() {
    return {
      timeout: 0,
      requestLocked: false,
      isgt: false,
      gtCode: '',
      gtStatus: false,
      // showImgCode: false
    }
  },
  created() {
    if (this.isCountDown) {
      this.timeout = 60;
      this.countDown();
      this.requestLocked = true;
    }
  },
  computed: {
    isTimeout() {
      return this.timeout > 0 || this.isCountDown;
    },
    ...mapGetters(['token','isDirection'])
  },
  methods: {
    countDown() {
      var _this = this;

      function tick() {
        _this.timeout--;
        if (_this.timeout > 0) {
          setTimeout(tick, 1000);
        } else {
          _this.requestLocked = false
          _this.countDownFun()
        }
      }

      tick();
    },
    sendCode() {
      // this.showImgCode = false
      var emailReg = /^\w+(?:\.\w+){0,2}@[a-zA-Z0-9]{2,14}(?:\.[a-z]{2,}){1,3}$/
      if ((this.codeType == 'phone' && !this.userName) || (this.codeType == 'phone' && this.userName.length < 5)) {
        this.errorFun();
        return false
      }
      if ((this.codeType == 'email' && !this.userName) || (this.codeType == 'email' && !emailReg.test(this.userName))) {
        this.errorFun();
        return false
      }
      if (this.codeType == 'phone') {
        var data = {
          phone: this.userName
        }
        if (this.countryCode) {
          data.areaCode = this.countryCode
        }
      } else if (this.codeType == 'email') {
        var data = {
          email: this.userName
        }
      } else {
        return false
      }
      if (this.timeout > 0 || this.requestLocked) {
        return false;
      } else {
        this.timeout = 60;
        this.countDown();
        this.requestLocked = true;
        // if (this.flag) {
        //     data.flag = this.flag
        // }
        if (this.validationToken) {
          data.validationToken = this.validationToken
        }
        data.behaviorToken = this.gtCode
        if (this.interfaceType == 'online') {
          //  在线--获取验证码
          onlineSendCode(this.codeType, data).then(res => {
            this.requestLocked = false;
            if (res.data.code == '200') {
              console.log(res,'看看不显示的res');
              this.successFun(res)
              // Toast(res.msg)
              Toast(res.data.msg)
            } else if (res.data.code == 501) {
              this.isGeet = true
              this.$nextTick(() => {
                this.isgt = !this.isgt
              })
              this.errorFun();
              this.timeout = 0;
              this.requestLocked = false;
            } else {
              this.timeout = 5;
              this.errorFun();
              // Toast(res.msg)
              Toast(res.data.msg)
            }
          }).catch(error => {
            // this.showImgCode = true
            this.errorFun();
            this.timeout = 0;
            this.requestLocked = false;
          })
        } else if (this.interfaceType == 'login') {
          // 登录--获取验证码
          loginSendCode(this.codeType, data).then(res => {
            this.requestLocked = false;
            if (res.code == '200') {
              this.successFun(res)
              Toast(res.msg)
            } else {
              this.timeout = 5;
              Toast(res.msg)
            }
          }).catch(error => {
            this.timeout = 0;
            this.requestLocked = false;
          })
        } else if (this.interfaceType == 'bind') {
          // 绑定--获取验证码
          data.behaviorToken = ''
          bindSendCode(this.codeType, data).then(res => {
            this.requestLocked = false;
            if (res.code == '200') {
              this.successFun(res)
              Toast(res.msg)
            } else {
              this.timeout = 5;
              Toast(res.msg)
            }
          }).catch(error => {
            this.errorFun(error);
            this.timeout = 0;
            this.requestLocked = false;
          })
        } else {
          data.type = this.formType == 'register' ? 1 : this.formType == 'resetPwd' ? 2 : ''
          // 其他类型--获取验证码
          sendCode(this.codeType, data).then(res => {
            this.requestLocked = false;
            if (res.code == '200') {
              this.successFun(res)
              Toast(res.msg)
            } else {
              this.timeout = 5;
              Toast(res.msg)
            }
          }).catch(error => {
            this.timeout = 0;
            this.requestLocked = false;
          })
        }

      }
    },
    GeetChange(val) {
      this.isgt = val;
    },
    serGeet() {
      if (this.timeout > 0 || this.requestLocked) return false
      if (this.formType == 'register' || this.formType == 'resetPwd') {
        this.isGeet = true
        this.$nextTick(() => {
          this.isgt = !this.isgt
        })
      } else {
        if (this.isGeet) {
          this.isgt = !this.isgt
          // this.showImgCode = true
        } else {
          this.sendCode()
        }
      }
    },
    GeetPath(val) {
      console.log("4,接受到图形验证参数，将参数发往服务端进行验证");
      console.log(val);
      this.gtCode = val
      // this.isgt = false;
      this.sendCode()
    },
    onVerify(res) {
      // 接受token
      this.gtCode = res
      this.sendCode()
    }

  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";

.code-num {
  position: absolute;
  top: torem(20);
  bottom: 0;
  width: max-content;
  cursor: pointer;
  @include sc(torem(12), #FFC72B);
}
.code-num-ltr{
  right: torem(10);
}
.code-num-rtl{
  left: torem(10);
}

.code-num.disabled, .code-num.disabled:hover {
  cursor: no-drop;
  background: none !important;
  @include sc(torem(12), #BCBCBC);
}

.model {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9999;

  /deep/ .van-icon {
    @include sc(torem(18), #333);
    margin-right: torem(20);
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/compontents/sendCode.vue